import React from 'react'
import bg from '../../images/background/5.jpg'

const VenueSection = (props) => {

    return (
        <section className="location-one"  style={{backgroundImage: `url(${bg})`}}>
            <div className="auto-container">
                <div className="sec-title title-anim centered">
                    <div className="sec-title_title">Venue</div>
                    <h2 className="sec-title_heading">Direction For The Retreat</h2>
                </div>
                <div className="row clearfix">
                    <div className="location-one_map-column col-lg-8 col-md-12 col-sm-12">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14204.154962826527!2d92.2448294047675!3d27.123589722784015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375b5856e746dabf%3A0xa01f80e43b7e2191!2sShergaon%20790002!5e0!3m2!1sen!2sin!4v1762674336384!5m2!1sen!2sin" allowFullScreen=""></iframe>
                    </div>
                    <div className="location-one_info-column col-lg-4 col-md-12 col-sm-12">
                        <div className="location-info_block">
                            <div className="location-info_block-inner">
                                <div className="location-info_block-content">
                                    <div className="location-info_block-icon flaticon-map"></div>
                                    <strong>ADDRESS</strong>
                                    Shergaon Village, Arunachal Pradesh
                                </div>
                            </div>
                        </div>
                        <div className="location-info_block">
                            <div className="location-info_block-inner">
                                <div className="location-info_block-content">
                                    <div className="location-info_block-icon flaticon-clock"></div>
                                    <strong>timing</strong>
                                    November 22 - 24, 2025
                                </div>
                            </div>
                        </div>
                        <div className="location-info_block">
                            <div className="location-info_block-inner">
                                <div className="location-info_block-content">
                                    <div className="location-info_block-icon flaticon-email-1"></div>
                                    <strong>MAIL TO US</strong>
                                    hello@thelushminds.in
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default VenueSection;